import React, { FC } from 'react';
import { Checkbox, FormGroup, FormControlLabel, Typography } from '@mui/material';
import cn from 'classnames';

interface Option {
  label: string;
  value: string;
}

interface CheckboxListProps {
  options: Array<Option>;
  selectedValues: Array<string>;
  setSelectedValues: (newValues: Array<string>) => void;
  titleText?: string;
  className?: string;
}

import './CheckboxList.scss';

const CheckboxList: FC<CheckboxListProps> = ({
  options,
  selectedValues,
  setSelectedValues,
  titleText = '',
  className = '',
}) => {
  const handleToggle = (value: string) => {
    if (selectedValues.includes(value)) {
      setSelectedValues(selectedValues.filter((v) => v !== value));
    } else {
      setSelectedValues([...selectedValues, value]);
    }
  };

  return (
    <div className={cn('checkbox-list')}>
      <Typography className="checkbox-list__title">{titleText}</Typography>
      <FormGroup
        row
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          flexWrap: 'wrap',
        }}
        className={cn('checkbox-list__box', className)}
      >
        {options.map((option) => (
          <FormControlLabel
            sx={{
              width: '32%',
              textWrap: 'nowrap',
            }}
            key={option.value}
            label={option.label}
            control={
              <Checkbox
                checked={selectedValues.includes(option.value)}
                onChange={() => handleToggle(option.value)}
              />
            }
          />
        ))}
      </FormGroup>
    </div>
  );
};

export default CheckboxList;
